import type { ICheckSocialLogin } from "../interface/customer";

const STORE_NAME = import.meta.env.VITE_REACT_APP_NAME as string;

interface IProps {
  email: string;
  domain: "ko" | "en" | "jp";
}

// common_sns_check
export const checkSocialLogin = async ({ email, domain }: IProps): Promise<ICheckSocialLogin | undefined> => {
  try {
    const url = "https://ompv4c3q4v4ncyzcybojlahr5i0tuwvt.lambda-url.ap-northeast-2.on.aws/";
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify({ storeName: STORE_NAME, domain, email }),
    }).then((res) => res);
    if (response.status === 200) {
      return (await response.json()) as ICheckSocialLogin;
    }
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(message);
  }
};
